import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { Switch, FormControlLabel } from '@mui/material';

// ----------------------------------------------------------------------

RHFSwitch.propTypes = {
  name: PropTypes.string,
  def: PropTypes.bool,
};

export default function RHFSwitch({ name, def, ...other }) {
  const { control } = useFormContext();

  return (
    <FormControlLabel
      control={
        <Controller 
          name={name} 
          control={control} 
          render={({ field: { value, onChange, ...field } }) => (
            <Switch 
              {...field} 
              checked={!!value} 
              onChange={(e, checked) => onChange(checked)}
            />
          )} 
        />
      }
      {...other}
    />
  );
}
